"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrowDown(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.936 0c.388 0 .708.288.76.662l.006.104v20.617l6.863-6.862a.766.766 0 01.997-.075l.086.075a.766.766 0 01.074.997l-.074.086-8.17 8.172a.769.769 0 01-.172.129l-.03.015a.622.622 0 01-.06.027l-.043.015a.604.604 0 01-.067.02.658.658 0 01-.108.016h-.016a.488.488 0 01-.046.002l-.044-.002a.77.77 0 01-.018-.001l.062.003a.77.77 0 01-.15-.015l-.02-.005a.606.606 0 01-.068-.018l-.042-.015a.595.595 0 01-.058-.025l-.032-.018a.672.672 0 01-.068-.041.747.747 0 01-.104-.087l-8.17-8.172a.766.766 0 01.998-1.157l.086.074 6.862 6.862V.766c0-.423.343-.766.766-.766z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgArrowDown;
exports.default = _default;